<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title *ngIf="Title">{{Title}}</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding" [scrollY]="false">
    <ion-grid style="height: 100%;">
        <ion-row style="height: 100%;">

            <ion-col [pushMd]="ViewDocument ? 6: ''" [pushXl]="ViewDocument?8:''" size="12"
                [sizeMd]="ViewDocument ? 6: 12" [sizeXl]="ViewDocument ? 4: 12" class="ion-padding-horizontal">

                <ion-row *ngIf="Templates?.length>1">

                    <ion-radio-group [value]="SelectedTemplate" (ionChange)="ChangeTemplate($event)">

                        <ion-item>
                            <ion-label position="stacked" required>Template do ficheiro</ion-label>
                            <ion-grid>
                                <ion-row>
                                    <ion-col *ngFor="let item of Templates">
                                        <ion-item lines="none">
                                            <ion-label>{{item?.Name}}</ion-label>
                                            <ion-radio slot="start" [value]="item"></ion-radio>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-item>
                    </ion-radio-group>

                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-item class="full" lines="full" fill="outline">
                            <ion-label position="stacked" i18n=":@@select_file_upload.upload" required>Ficheiro
                            </ion-label>

                            <input-browse [fileName]="File?.OriginalName" [fileURL]="File?.Path"
                                [accept]="FileFormatsAllowed" (callback)="OnChangeFile($event)"></input-browse>

                            <a *ngIf="FileTemplate" [href]="FileTemplate">descarregar ficheiro template</a>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="Type==ENUMTypeDocument.Load && Modules?.length>0" class="ion-margin-top">

                    <ion-radio-group [value]="SelectedModule" (ionChange)="ChangeModule($event)">

                        <ion-item>
                            <ion-label position="stacked" required>Módulos</ion-label>
                            <ion-grid>
                                <ion-row>
                                    <ion-col *ngFor="let item of Modules">
                                        <ion-item lines="none">
                                            <ion-label>{{item?.Name}}</ion-label>
                                            <ion-radio slot="start" [value]="item"></ion-radio>
                                        </ion-item>
                                    </ion-col>

                                </ion-row>
                            </ion-grid>
                        </ion-item>
                    </ion-radio-group>

                </ion-row>

                <ion-row>
                    <ion-col class="flex-center-custom" *ngIf="Type==ENUMTypeDocument.Load">
                        <ion-button i18n=":@@select_file_upload.process_btn" [disabled]="ValueErrors?.length > 0"
                            (click)="OnUploadFile()">Carregar
                            ficheiro</ion-button>

                        <ion-button *ngIf="HasOnLoad" fill="outline" (click)="OnRefresh($event)">
                            <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
                        </ion-button>
                    </ion-col>
                    <ion-col class="flex-center-custom" *ngIf="Type==ENUMTypeDocument.Select">
                        <ion-button i18n=":@@select_file_upload.save_btn" (click)="OnUploadFile()">Guardar
                            ficheiro</ion-button>

                        <ion-button *ngIf="HasOnLoad" fill="outline" (click)="OnRefresh($event)">
                            <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
                        </ion-button>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="HasOnLoad">
                    <ion-col size="12">
                        <ion-list *ngIf="ProcessList?.length > 0">
                            <ion-list-header>
                                <b>Processos</b>
                            </ion-list-header>
                            <ion-grid class="table">

                                <ion-row class="table-header">
                                    <ion-col class="flex-align-center">Estado</ion-col>
                                    <ion-col class="flex-align-center">Ficheiro</ion-col>
                                    <ion-col class="flex-align-center buttons-size-2">Data</ion-col>
                                    <ion-col class="flex-align-center buttons-size-2"></ion-col>
                                </ion-row>

                                <ion-row class="table-body with-button-opacity"
                                    *ngFor="let item of PagedProcessList; let i = index">
                                    <ion-col class="flex-align-center">{{item?.Status?.Name}}</ion-col>
                                    <ion-col class="flex-align-center">{{item?.OutputFile?.OriginalName ||
                                        '--'}}</ion-col>
                                    <ion-col class="flex-align-center buttons-size-2">

                                        <date-tooltip [date]="item?.CreateDate"></date-tooltip>
                                    </ion-col>
                                    <ion-col class="flex-justify-end buttons-size-2">

                                        <ion-icon *ngIf="item?.ExecutedWithErrors" [title]="item?.ExecutionErrorMessage"
                                            name="warning-outline"></ion-icon>

                                        <ion-button *ngIf="item?.OutputFile" fill="clear" size="small"
                                            (click)="OnView($event, item)">
                                            <ion-icon name="open-outline" slot="icon-only"></ion-icon>
                                        </ion-button>
                                    </ion-col>
                                </ion-row>

                            </ion-grid>

                            <pagination-control [page]="PageNumber" [itemsForPageSelected]="PageRows"
                                [totalItems]="ProcessList?.length" (pageChange)="OnChangePage($event)">
                            </pagination-control>

                        </ion-list>

                        <no-items *ngIf="ProcessList?.length==0"></no-items>
                    </ion-col>
                </ion-row>
            </ion-col>

            <ion-col pullMd="6" pullXl="4" size="12" sizeMd="6" sizeXl="8" *ngIf="ViewDocument"
                class="ion-align-content-center document-view-col" style="height: 100%; background: white;">


                <div *ngIf="!XMLData && ExcelData?.length > 0" class="excel-data-wrapper">

                    <div *ngIf="ValueErrors?.length > 0" class="values-errors-header">
                        <div class="values-errors-summary">
                            <ion-icon name="warning-outline"></ion-icon>
                            {{ValueErrors.length}} campo(s) inválido(s) encontrado(s) nos dados. Corrija o ficheiro e
                            carregue-o novamente.
                        </div>
                        <ion-button size="small" [fill]="ShowOnlyErrors ? 'solid' : 'outline'" color="danger"
                            (click)="ToggleShowOnlyErrors()">
                            <ion-icon slot="start" name="funnel-outline"></ion-icon>
                            Mostrar só erros
                        </ion-button>
                    </div>

                    <cdk-virtual-scroll-viewport itemSize="28">
                        <table class="ion-table" style="border-collapse: collapse; width: 100%;">
                            <thead>
                                <tr style="background-color: #eee;">
                                    <th *ngFor="let header of ExcelData[0]"
                                        style="border: 1px solid #ccc; padding: 8px;">
                                        {{ header }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Use *cdkVirtualFor em vez de *ngFor -->
                                <tr *cdkVirtualFor="let row of GetDataRows(); trackBy: TrackByRowIndex">
                                    <td *ngFor="let cell of row.Cells; let j = index"
                                        [class.cell-error]="HasCellError(row.RowIndex, j)"
                                        [title]="GetCellError(row.RowIndex, j)"
                                        style="font-size: 12px; border: 1px solid #ccc; padding: 2px 6px;">
                                        {{ cell }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </cdk-virtual-scroll-viewport>
                </div>

                <div *ngIf="(!ExcelData || ExcelData?.length==0) && XMLData"
                    style="font-family: monospace; white-space: pre-wrap; height: 100%;">
                    <json-tree-view [key]="RootKey" [value]="XMLData"></json-tree-view>
                </div>

                <no-items icon="document-outline" [description]="!File && Errors ? Errors : 'selecione o ficheiro'"
                    *ngIf="!XMLData && ExcelData?.length==0"></no-items>

            </ion-col>


        </ion-row>
    </ion-grid>
</ion-content>